import React, { useMemo, useRef, useState, useEffect } from "react";
import "./css/TestimonialSection.css";
import Img from "../assets/testimoinail-img.jpg";
import Mletter from "../assets/m-letter.png";
import davidImg from "../assets/david.png";
import rLetter from "../assets/r-letter.png";


const DEFAULT_TESTIMONIALS = [
    {
        id: 1,
        quote:
            "I had a great experience at merchant marvels. The staff was professional and knowledgeable. They provide very good and transparent prices.",
        name: "Manish Chugh",
        role: "",
        stars: 5,
        avatar: Mletter, // replace
    },
    {
        id: 2,
        quote:
            "Great customer service, very responsive, very friendly to work with and fees are reasonable. Recommend to all retailers to try them",
        name: "daVid kong",
        role: "",
        stars: 5,
        avatar: davidImg,  // replace
    },
    {
        id: 3,
        quote:
            "Saw their advertisement on Instagram Got clover station for Free. I was not sure while signing up but got quick delivery as well all setup done quickly",
        name: "Rebeca Garcia",
        role: "",
        stars: 5,
        avatar: rLetter,  // replace
    },
];



export default function TestimonialSection({

    testimonials = DEFAULT_TESTIMONIALS,
    title = "Hear From\nOur Satisfied\nClients",
}) {





    const slides = useMemo(() => testimonials.filter(Boolean), [testimonials]);
    const [index, setIndex] = useState(0);

    const startX = useRef(null);
    const dx = useRef(0);
    const [paused, setPaused] = useState(false);

    const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);
    const next = () => setIndex((i) => (i + 1) % slides.length);

    // AUTO SLIDER (every 4 seconds)
    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((i) => (i + 1) % slides.length);
        }, 4000); // 4 seconds

        return () => clearInterval(timer);
    }, [slides.length]);



    // keyboard support
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "ArrowLeft") prev();
            if (e.key === "ArrowRight") next();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides.length]);

    // swipe
    const onTouchStart = (e) => {
        startX.current = e.touches[0].clientX;
        dx.current = 0;
    };
    const onTouchMove = (e) => {
        if (startX.current == null) return;
        dx.current = e.touches[0].clientX - startX.current;
    };
    const onTouchEnd = () => {
        if (startX.current == null) return;
        const dist = dx.current;
        startX.current = null;
        dx.current = 0;
        if (Math.abs(dist) > 50) dist > 0 ? prev() : next();
    };

    return (
        <section className="tsWrap">
            <div className="tsInner">
                {/* LEFT */}
                <div className="tsLeft">
                    <div className="tsLayers" aria-hidden="true">
                        <div className="tsLayer l1" />
                        <div className="tsLayer l2" />
                        <div className="tsLayer l3" />
                    </div>

                    <h2 className="tsHeading">
                        {title.split("\n").map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </h2>
                </div>

                {/* RIGHT */}
                <div className="tsRight">
                    <div
                        className="tsSlider"
                        onMouseEnter={() => clearInterval(window.tsTimer)}
                        onMouseLeave={() => {
                            window.tsTimer = setInterval(() => {
                                setIndex((i) => (i + 1) % slides.length);
                            }, 4000);
                        }}

                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}
                    >
                        {/* viewport prevents next slide peeking */}
                        <div className="tsViewport">
                            <div
                                className="tsTrack"
                                style={{ transform: `translate3d(-${index * 100}%,0,0)` }}
                            >
                                {slides.map((t) => (
                                    <div className="tsSlide" key={t.id}>
                                        <p className="tsQuote">{t.quote}</p>

                                        <div className="tsPersonRow">
                                            <div className="tsAvatarWrap">
                                                <img className="tsAvatar" src={t.avatar} alt={t.name} />
                                            </div>

                                            <div className="tsMeta">
                                                <Stars count={t.stars ?? 5} />
                                                <div className="tsName">{t.name}</div>
                                                <div className="tsRole">{t.role}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Controls */}
                        <button className="tsArrow tsPrev" type="button" onClick={prev} aria-label="Previous">
                            ‹
                        </button>
                        <button className="tsArrow tsNext" type="button" onClick={next} aria-label="Next">
                            ›
                        </button>

                        <div className="tsDots">
                            {slides.map((_, i) => (
                                <button
                                    key={i}
                                    type="button"
                                    className={`tsDot ${i === index ? "isActive" : ""}`}
                                    onClick={() => setIndex(i)}
                                    aria-label={`Go to testimonial ${i + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Stars({ count = 5 }) {
    const arr = Array.from({ length: 5 }, (_, i) => i < count);
    return (
        <div className="tsStars" aria-label={`${count} out of 5 stars`}>
            {arr.map((on, i) => (
                <span key={i} className={`tsStar ${on ? "on" : ""}`} aria-hidden="true">
                    ★
                </span>
            ))}
        </div>
    );
}
